import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchOrganizationDetails } from '../api/generalApi';

export const getOrganizationDetails = createAsyncThunk('organizationData/getOrganizationDetails', async ({payload}, { rejectWithValue }) => {
  try {
    const response = await fetchOrganizationDetails(payload);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});


const generalSlice = createSlice({
  name: 'general',
  initialState: {
    organizationData: [],
    isLoading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getOrganizationDetails.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getOrganizationDetails.fulfilled, (state, action) => {
        state.isLoading = false;
        state.organizationData = action.payload;
      })
      .addCase(getOrganizationDetails.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
  },
});

export default generalSlice.reducer;
